<template>
  <div class="produk">
    <!-- <SearchView />    -->
    <div class="title-bar" style="background-color: #C039FF;">
        <div class="row text-white" style="padding: 15px 150px;">
        <div class="col-12 col-md-6 text-left" style="font-family: 'Manrope'; font-size: 16px; font-weight: 700;">
          Tentang
        </div>
        <div class="col-12 col-md-6" style="font-family: 'Poppins'; font-size: 14px; font-weight: 500;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Tentang" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
    <div class="bg-image" style="padding: 100px 150px; text-align: center;">
        <q-card class="my-card q-pa-xl" flat bordered>
      <q-card-section horizontal>
        <q-card-section class="text-left">
            <div style="font-family: 'Manrope'; font-weight: bold; font-size: 36px; color: #212529; padding-bottom: 25px;">
                Tentang Marina
            </div>
            <div style="font-family: 'Poppins'; font-size: 14px; color: #7A7A7A; text-align: justify; padding-bottom: 30px;">
            <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ratione, recusandae
            necessitatibus quasi incidunt alias adipisci pariatur earum iure beatae assumenda
            rerum quod. Tempora magni autem a voluptatibus neque.
            </p>
            <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ratione, recusandae
            necessitatibus quasi incidunt alias adipisci pariatur earum iure beatae assumenda
            rerum quod. Tempora magni autem a voluptatibus neque.
            </p>
            <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ratione, recusandae
            necessitatibus quasi incidunt alias adipisci pariatur earum iure beatae assumenda
            rerum quod. Tempora magni autem a voluptatibus neque.
            </p>
            </div>
            <div class="row text-center" style="background-color: #F7F7F8; padding: 15px 0; border: solid 0.5px #E9E9E9; border-radius: 5px;">
                <div class="col-4" style="font-family: 'Manrope'; font-size: 35px; font-weight: bold; color: #C039FF;">
                    243
                </div>
                <div class="col-4" style="font-family: 'Manrope'; font-size: 35px; font-weight: bold; color: #C039FF;">
                    532
                </div>
                <div class="col-4" style="font-family: 'Manrope'; font-size: 35px; font-weight: bold; color: #C039FF;">
                    1239
                </div>
                <div class="col-4" style="font-family: 'Manrope'; font-size: 14px; font-weight: 600; color: #212529;">
                    Pelaku Usaha
                </div>          
                <div class="col-4" style="font-family: 'Manrope'; font-size: 14px; font-weight: 600; color: #212529;">
                    Pelanggan
                </div>          
                <div class="col-4" style="font-family: 'Manrope'; font-size: 14px; font-weight: 600; color: #212529;">
                    Produk
                </div>                
            </div>
        </q-card-section>

        <q-img
          class="col-5 q-ma-lg"
          src="img/shop.png"
        />
      </q-card-section>
    </q-card>
    </div>
  </div>
</template>

<script>

import { ref } from 'vue'
// import SearchView from '@/views/SearchView.vue'

export default {
  name: 'TentangView',
  // components: {
  //   SearchView
  // },
  data () {
    return {
        counter: 1,
        produk : '',
        ingat: ref(false),
        id : this.$route.params.id,
        judul : this.$route.params.judul,
        list_produk : [{id : '1', judul : 'Buah Nangka', harga : '40.000', diskon : '53.000'}, {id : '2', judul : 'Kursi Rotan', harga : '120.000', diskon : '150.000'}, {id : '3', judul : 'Nasi Goreng', harga : '20.000', diskon : '23.000'}]
    }
  },

  methods: {
    getView() {
        console.log(this.id);
        console.log(this.judul);
    },
    changeCounter: function(num){
        this.counter += +num
        console.log(this.counter)
        !isNaN(this.counter) && this.counter > 0 ? this.counter : this.counter = 0;
    }
  },

  mounted() {
    this.getView();
    this.changeCounter();
  }

}
</script>
